<template>
    <!--用车人评价-->
    <div class="view" :style="{paddingTop:navbarheight}">
        <div class="content">
            <my-top title="用车申请记录" lefttext="返回" @leftclick="togo('/application/travelApplication')"></my-top>
            <!--<div class="screenbox" :style="{top:navbarheight}">-->
                <!--<div class="sarch">-->
                    <!--<search v-model="query.query.useCarTime"-->
                            <!--placeholder="搜索"-->
                            <!--@blur="searchLoad"-->
                            <!--input-align="center" />-->
                <!--</div>-->
            <!--</div>-->
            <cell style="background-color: #f2f2f2" :title="'总申请数：'+totalSize"></cell>
            <pull-refresh v-model="refreshing" @refresh="onRefresh">
                <list class="cont-box"
                      v-model="loading"
                      :finished="finished"
                      finished-text="没有更多了"
                      @load="getlistdata">
                    <div class="item-box">
                        <!--<cell style="background-color: #F5F5F5;">-->
                            <!--<template #title>-->
                                <!--{{new Date(item.time).getMonth()+1}}月{{new Date(item.time).getDate()}}日 {{item.week}}-->
                            <!--</template>-->
                            <!--<template #default>-->
                                <!--<span style="color:#000;">{{new Date(item.time).getFullYear()}}年</span>-->
                            <!--</template>-->
                        <!--</cell>-->
                        <cell v-for="(items, m) in list" :key="m" class="simpleList" @click.stop="handleClick(items)">
                            <template #title>
                                <div style="overflow: hidden">
                                    <div class="listItem">
                                        <div style="max-width: calc(100% - 80px); float: left;font-weight: bold;font-size: 15px;">
                                            <div class="van-ellipsis">目的地：{{items.address}}</div>
                                        </div>
                                        <div class="listVal van-ellipsis" style="font-size: 1.2rem;color: #969799;">
                                            {{items.modifiedTime}}
                                            <!--出行状态0未开始 1使用中 2已归队-->
                                            <span v-if="items.travelStatus==2" style="color: #999999">已结束</span>
                                            <span v-else-if="items.travelStatus == 0" style="color: #02bd6e">未开始</span>
                                            <span v-else-if="items.travelStatus == 1" style="color: #FFA500">进行中</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template #label>
                                <div class="van-ellipsis">
                                    <div class="van-ellipsis">往返时间：{{items.goTime}} 至 {{items.comeTime}}</div>
                                    <div class="van-ellipsis">车型要求：{{items.requirement}}</div>
                                    <div class="listItem">
                                        <div style="max-width: calc(100% - 80px); float: left;font-size: 1.2rem;">
                                            <div class="van-ellipsis">用车人员：{{items.usePersonNames}}</div>
                                        </div>
                                        <div class="listVal van-ellipsis" style="font-size: 1.2rem;color: #969799;">
                                            <span v-if="items.status === 0" style="color: #02bd6e">待提交审批</span>
                                            <span v-else-if="items.status === 1" style="color: #018FE0">审批中</span>
                                            <span v-else-if="items.status === 2" style="color: #999999">审批通过</span>
                                            <span v-else-if="items.status === 3" style="color: #f00">审批不通过</span>
                                            <span v-else-if="items.status === 4" style="color: #999999">未填报</span>
                                        </div>
                                    </div>
                                    <!--<div class="listItem">-->
                                        <!--<div class="listVal van-ellipsis">-->
                                            <!--<span >-->
                                                <!--<span style="margin-right: 10px;">已评价</span>-->
                                                <!--<Button plain type="info" size="small">查看评价</Button>-->
                                            <!--</span>-->
                                            <!--<span >-->
                                            <!--&lt;!&ndash;<span v-else-if="!items.isEvaluate">&ndash;&gt;-->
                                                <!--<Button plain type="info" size="small">评价</Button>-->
                                            <!--</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                </div>
                            </template>
                        </cell>
                    </div>
                </list>
            </pull-refresh>
        </div>
    </div>
</template>

<script>
    import {Button, Cell, Icon, List, PullRefresh, Search} from 'vant';
    import application from '@api/application';

    export default {
        name:'useCar',
        components: {Cell,Search,List,PullRefresh,Button,Icon},
        data() {
            return {
                token: this.$store.state.user.token,
                projectId: this.$store.state.project.projectId,
                searchvalue: '',
                list: [],
                loading: false,
                finished: false,
                refreshing: false,
                totalSize:0,
                rotate:true,
                sortName: '正序',
                query: {
                    pageNo: 1,
                    pageSize: 10,
                    query: {
                        unitId: JSON.parse(localStorage.getItem("vuex")).user.company.id,
                        useApp:'1', //useApp区分app上的数据
                        useCarTime:''
                    }
                },
            }
        },
        computed:{

        },
        methods: {
            /**
             * 司机信息展示
             **/
            handleClick(items){
                let path='/application/travelApplication/detail'
                if(items.status === 3){
                    path= '/application/travelApplication'
                }
                this.$router.push({
                    path: path,
                    query:{
                        id:items.id,
                        editModel: '2' // 该状态为编辑
                    }
                })
            },
            getlistdata(type='add') {
                if(this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                if(type=='new') {
                    this.list = [];
                    this.query.pageNo=1;
                    this.loading = true;
                    this.finished = false;
                }
                application.carApplyList(this.query).then(res=> {
                    if(res.code == 200) {
                        this.list = this.list.concat(res.data);
                        this.query.pageNo++;
                        this.totalSize = res.totalSize
                        this.loading = false;
                        if(res.currentPage>=res.totalPage) {
                            this.finished = true;
                        }
                    }else {
                        this.loading = false;
                        this.finished = true;
                    }
                }).catch(err => {
                    this.loading = false;
                    this.finished = true;
                })
            },
            searchLoad() {
                this.getlistdata('new');
            },
            onRefresh() {
                this.getlistdata('new');
                this.finished = false;
                this.loading = true;
            },
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .down{
        transition: all 1ms;
    }
    .up{
        transform:rotate(-180deg);
        transition: all 1ms;
    }

    .view{
        background-color: #FFFFFF;
    }
    .content {
        padding-bottom:50px;
        .screenbox {
            width:100%;
            position:fixed;
            left:0;
            z-index:2;
            .sarch {
                ::v-deep .van-search{
                    .van-search__content {
                        border-radius:20px;
                    }
                }
            }
            .sarchtabs {
                ::v-deep .van-tabs__line{
                    background-color:#018fe0;
                    bottom: 18px;
                }
            }
        }
        .cont-box {
            /*padding: 1rem;*/
            .item-box {
                background-color: #FFFFFF;
                overflow: hidden;
                .van-cell__title{
                    overflow: hidden;
                }
                .titBtn{
                    display: inline-block;
                    font-size: 12px;
                    padding: 2px 8px;
                    margin-left: 10px;
                    border-radius:4px;
                }
                .titBtn.err{
                    color: #F5222D;
                    border:1px solid #FFA39E;
                    background-color: #FEF0EF;
                }
                .titBtn.default{
                    color: #000000;
                    border:1px solid #D9D9D9;
                    background-color: #F5F5F5;
                }
            }
            .simpleList{
                border-bottom: 1px solid #dddddd;
                display:flex;
                /*justify-content: center;*/
                align-items: center;
                ::v-deep .van-ellipsis{
                    line-height: 20px;
                }
                .listItem{
                    font-size: 14px;
                    display: flex;
                    display: -webkit-box;
                    display: -webkit-flex;
                    box-sizing: border-box;
                    width: 100%;
                    line-height: 24px;
                    white-space: normal;
                    text-align: left;
                    overflow: hidden;
                    .listTitle, .listVal{
                        flex: 1;
                        -webkit-box-flex:1;
                        -webkit-flex:1;
                    }
                    .listVal{
                        text-align: right;
                    }
                }
                .listCtn{
                    color: #999999;
                    font-size: 12px;
                    .listVal{
                        font-size: 12px;
                    }
                }
                .listBtn{
                    .listTitle{
                        color: #018fe0;
                    }
                }
            }
        }
        .btn {
            >span:first-child {
                background-color:#70B603;
            }
            >span:last-child {
                background-color:#169BD5;
            }
        }
    }

</style>
